export const STATUSES = [
  "status",
  "leaving",
  "pending",
  "new",
  "churn",
  "promoter",
  "never_registered",
  "active",
  "adopter",
  "user",
  "activated",
];